import Store from "@/store/index.js";
import axios from "axios";
const domain = Store.state.domain;

export default {
  async ObtenerAfianzadoras() {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ObtenerAfianzadoras`
    );
    return response.data;
  },
  async AltaFianzas(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/AltaFianzas`,
      data
    );
    return response.data;
  },
  async BusquedaFianzasTam(datos) {
    var formData = new FormData();
    formData.append("afianzadora", datos.afianzadora);
    formData.append("estatus", datos.estatus);
    formData.append("folio", datos.folio);
    formData.append("responsable", datos.responsable);
    formData.append("numReg", datos.numReg);
    formData.append("numPag", datos.numPag);
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/BusquedaFianzasTam`,
      formData
    );

    return response.data;
  },
  async DetalleFianza(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/DetalleFianza`,
      data
    );
    return response.data[0];
  },
  async ObtenerResponsables() {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ObtenerResponsables`
    );
    return response.data;
  },
  async ObtenerEstatus() {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ObtenerEstatus`
    );
    return response.data;
  },
  async AsignarFianza(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/AsignarFianza`,
      data
    );
    return response.data;
  },
  async ConceptosFianza() {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ConceptosFianza`
    );
    return response.data;
  },
  async VerificarReporte(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/VerificarReporte`,
      data
    );
    return response.data[0];
  },
  async UtilizarFianza(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/UtilizarFianza`,
      data
    );
    return response.data;
  },
  async ResguardarFianza(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ResguardarFianza`,
      data
    );
    return response.data;
  },
  async CancelarFianzas(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/CancelarFianzas`,
      data
    );
    return response.data;
  },
  async LimpiarFianzas(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/LimpiarFianzas`,
      data
    );
    return response.data;
  },
  async ObtenerCorrespondencia(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ObtenerCorrespondencia`,
      data
    );
    return response.data;
  },
  async RecibirFianza(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/RecibirFianza`,
      data
    );
    return response.data;
  },
  async CambiarANoCorresponde(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/CambiarANoCorresponde`,
      data
    );
    return response.data;
  },
  async NotificacionPresentacion(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/NotificacionPresentacion`,
      data
    );
    return response.data[0];
  },
  async ProcesoNotificacion(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ProcesoNotificacion`,
      data
    );
    return response.data;
  },
  async ObtenerFianzaConceptos(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ObtenerFianzaConceptos`,
      data
    );
    return response.data;
  },
  async guardarFecha(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/guardarFecha`,
      data
    );
    return response.data;
  },
  async RecuperarFianza(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/RecuperarFianza`,
      data
    );
    return response.data;
  },
  async HacerEfectiva(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/HacerEfectiva`,
      data
    );
    return response.data;
  },
  async ValidarReporte(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ValidarReporte`,
      data
    );
    return response.data;
  },
  async ValidarFolios(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Fianzas/ValidarFolios`,
      data
    );
    return response.data;
  },
};
